export default {
    baseStyle: {
        checkboxStyle: {
            marginTop: '1rem',
            alignItems: 'start',
            '.chakra-checkbox__control': {
                marginTop: '0.4rem',
                _invalid: {
                    borderColor: 'red.550',
                    bg: 'red.750',
                    color: 'red.550'
                }
            }
        },
        checkboxText: {
            fontSize: 'sm',
            color: 'gray.700'
        },
        staticLabel: {
            fontWeight: 'bold',
            textTransform: 'uppercase',
            fontSize: '13px',
            display: 'block',
            width: {base: '100%', md: '47%'},
            marginRight: '12px'
        },
        toolTip: {
            bg: 'blackAlpha.150',
            color: 'white',
            fontSize: 'md',
            fontWeight: '400',
            placement: 'end'
        },
        toolTipIcon: {
            position: 'absolute',
            as: 'span',
            top: '30%',
            right: {base: '-3.8%', sm: '-2.4%', md: '-4%', lg: '-7%'},
            bg: 'blackAlpha.250',
            color: 'white',
            borderRadius: 'full',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            w: {base: '13px', md: '15px'},
            h: {base: '13px', md: '15px'},
            fontSize: 'xs',
            fontWeight: 'bold',
            cursor: 'pointer'
        },
        toolTipIconLandline: {
            position: 'absolute',
            as: 'span',
            top: '30%',
            right: {base: '-3.8%', sm: '-2.4%', md: '-4%', lg: '-7%'},
            bg: 'blackAlpha.250',
            color: 'white',
            borderRadius: 'full',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            w: {base: '13px', md: '15px'},
            h: {base: '13px', md: '15px'},
            fontSize: 'xs',
            fontWeight: 'bold',
            cursor: 'pointer'
        },
        link: {
            position: 'relative'
        },
        addInfoPref: {
            borderTop: '1px solid lightgray',
            marginTop: '30px',
            paddingTop: '10px',
            display: 'flex',
            alignItems: 'center'
        },
        dobBox: {
            flexDirection: 'row',
            width: '100%',
            position: 'relative'
        },
        addDeliveryInfo: {
            transition: 'transform 0.3s ease'
        },
        addressCompany: {
            gap: 5,
            flexDirection: 'column',
            overflow: 'hidden',
            transition: 'max-height 0.6s ease-out, opacity 0.6s ease-out'
        },
        alignfield: {
            alignItems: {base: 'flex-start', md: 'center'},
            display: 'flex',
            flexDirection: {base: 'column', md: 'row'}
        },
        postCity: {
            gap: 3,
            width: '100%'
        },
        formStack: {
            spacing: 5,
            border: 'none!important'
        },
        landlineBox: {
            position: 'relative'
        },
        phone: {
            position: 'relative',
            width: '100%'
        },
        phoneLabel: {
            width: {base: '100%', md: '47%'},
            marginBottom: '0',
            fontSize: '13px',
            fontWeight: '700'
        },
        toolTipIconMobile: {
            position: 'absolute',
            as: 'span',
            top: '30%',
            right: {base: '-3.8%', sm: '-2.5%', md: '-4%', lg: '-7%'},
            bg: 'blackAlpha.250',
            color: 'white',
            borderRadius: 'full',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            w: {base: '11.5px', sm: '11px', md: '15px'},
            h: {base: '11.5px', sm: '11px', md: '15px'},
            fontSize: 'xs',
            fontWeight: 'bold',
            cursor: 'pointer'
        },
        toolTipBirthday: {
            position: 'absolute',
            as: 'span',
            top: {base: '55%', md: '30%'},
            right: {base: '-3.8%', sm: '-2.5%', md: '-2.8%', lg: '-4.7%'},
            bg: 'blackAlpha.250',
            color: 'white',
            borderRadius: 'full',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            w: {base: '11.5px', sm: '11px', md: '15px'},
            h: {base: '11.5px', sm: '11px', md: '15px'},
            fontSize: 'xs',
            fontWeight: 'bold',
            cursor: 'pointer'
        },
        dobBoxday: {
            width: {base: '100%', md: '30%'}
        },
        dobBoxmonth: {
            width: {base: '100%', md: '40%'}
        },
        dobBoxyear: {
            width: {base: '100%', md: '30%'}
        },
        dobSelect: {
            padding: '0',
            paddingLeft: '8px',
            paddingRight: '0',
            paddingInlineStart: '0',
            paddingInlineEnd: '0'
        },
        globalFlex: {
            display: 'flex',
            alignItems: {base: 'start', md: 'center'},
            flexDirection: {base: 'column', md: 'row'},
            _error: {
                borderColor: 'red.550!important',
                boxShadow: '0 0 0 1px red.550!important'
            }
        },
        phoneFlex: {
            alignItems: {base: 'start', md: 'center'},
            flexDirection: {base: 'column', md: 'row'}
        },
        phoneInput: {
            paddingLeft: '51px',
            height: '42px'
        }
    }
}
